const info = {
    $schema: '../assetlist.schema.json',
    chain_name: 'chain4energy',
    assets: [{
            description: 'The native token of Chain4Energy',
            extended_description: 'C4E is a DePIN L1 Blockchain platform, designed to support a variety of innovative energy and e-mobility applications by creating a decentralized and democratized community-powered ecosystem.',
            denom_units: [{
                    denom: 'uc4e',
                    exponent: 0
                }, {
                    denom: 'c4e',
                    exponent: 6
                }],
            base: 'uc4e',
            name: 'Chain4Energy',
            display: 'c4e',
            symbol: 'C4E',
            logo_URIs: {
                png: 'https://raw.githubusercontent.com/cosmos/chain-registry/master/chain4energy/images/c4e.png'
            },
            coingecko_id: 'chain4energy',
            images: [{
                    png: 'https://raw.githubusercontent.com/cosmos/chain-registry/master/chain4energy/images/c4e.png',
                    theme: {
                        primary_color_hex: '#24344c'
                    }
                }],
            socials: {
                website: 'https://c4e.io/',
                twitter: 'https://twitter.com/Chain4Energy'
            }
        }]
};
export default info;
